import { XIcon } from "@heroicons/react/outline";
import React from "react";

interface Props {
  content: string;
  onClose?: () => void;
  linkTitle: string;
  onClick: () => void;
}

const NotificationBar: React.FC<Props> = ({
  content,
  onClose,
  onClick,
  linkTitle
}) => (
  <div className="relative bg-yellow-600 bg-opacity-60">
    <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
      <div className="text-center">
        <p className="font-medium text-white">
          <span className="md:inline">{content}</span>
          <span className="block sm:ml-2 sm:inline-block">
            <span
              onClick={() => onClick && onClick()}
              className="text-white font-bold underline cursor-pointer"
            >
              {linkTitle} <span aria-hidden="true">&rarr;</span>
            </span>
          </span>
        </p>
      </div>
      {onClose && (
        <div className="absolute inset-y-0 right-0 pt-1 pr-1 flex items-start sm:pt-1 sm:pr-2 sm:items-start">
          <button
            type="button"
            onClick={onClose}
            className="flex p-2 rounded-md hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-white"
          >
            <span className="sr-only">Dismiss</span>
            <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
          </button>
        </div>
      )}
    </div>
  </div>
);

export default NotificationBar;
